import React from 'react'
import { Modal, Form, Col, Row, Button } from 'react-bootstrap'
import { createModal, ModalResolveType, useModalAction } from '@src/lib/modal-manager'
// import './style.scss'

interface EditCarPartProps {
  dtoUuid?: string;
}

export function EditCarPartModalWrapper(props: EditCarPartProps) {
  const { resolve, remove, hide } = useModalAction()
  const { dtoUuid } = props
  
  const handleClose = () => {
    resolve(ModalResolveType.CLOSED)
    hide()
    remove()
  }

  const handleCancel = () => {
    resolve(ModalResolveType.CANCEL)
    hide()
    remove()
  }

  const handleSubmit = () => {
    resolve(ModalResolveType.OK)
    hide()
    remove()
  }

  return (
    <Modal size='lg' show onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{`${dtoUuid ? '編輯' : '新增'}組裝區域`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              狀態
            </Form.Label>
            <Col sm="10">
            <Form.Select>
              <option>啟用</option>
              <option>停用</option>
            </Form.Select>
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleCancel} variant="light">
          取消
        </Button>
        <Button onClick={handleSubmit}>
          確認
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const EditCarPartModal = createModal(EditCarPartModalWrapper)
